module.exports = "/img/8.56e60b.webp";